import keyMirror from 'keymirror-nested'

export default keyMirror({
  FILTERS: {
    UPDATE: null,
    DELETE: null,
    DELETE_ADVANCED: null,
  },
})
